import { Route, Routes, Navigate, HashRouter } from "react-router-dom";
import Sidebar from './components/Sidebar/Sidebar';
import "./App.css";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import Dashboard from './pages/Dashboard/Dashboard';
import Alerts from './pages/Alerts/Alerts';
import LoadProfile from './pages/Settings/LoadProfile/LoadProfile';
import AlertEmails from './pages/Settings/EmailAddresses/AlertEmails';
import Logs from "./pages/Logs/Logs";
import Integrations from "./pages/Integrations/Intergrations";
import LogManagement from "./pages/Settings/LogManagement/LogManagement";
import LoginRedirectHandler from "./pages/Login/LoginRedirectHandler";

function App() {
  return (
    <div>
      <HashRouter>
        <AuthenticatedTemplate>
          <Routes>
            <Route path="/" element={<Sidebar />} >
              <Route index element={<Dashboard />} />
              <Route path="logs" element={<Logs />} />
              <Route path="integrations" element={<Integrations />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="settings">
                <Route path="loadprofile" element={<LoadProfile />} />
                <Route path="alertemails" element={<AlertEmails />} />
                <Route path="logmanagement" element={<LogManagement />} />
              </Route>
              <Route path="*" element={<Navigate to="/" />} />
            </Route>
          </Routes>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <LoginRedirectHandler />
        </UnauthenticatedTemplate>
      </HashRouter>
    </div>
  );
}

export default App;
